import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";

import { EMPTY_STRING, surveyFiledsTypes } from "../../constants";
import { CloseAdminModalIcon } from "../../assets";
import FeaturesIconMapping from "../../assets/icons/FeaturesIconMapping";
import CustomSvg from "../../shared/components/custom-svg/CustomSvg";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import SurveyFormField from "../../shared/components/surveyFormField/SurveyFormField";

const { TYPE_RADIO } = surveyFiledsTypes;

const AmenitiesModal = ({
  show = true,
  closeModal = () => {},
  ammenities = [],
  selectedAmenities = [],
  handleAmenityChange = () => {},
  handleFindByAmenities = () => {},
}) => {
  const methods = useForm({
    mode: "onChange",
  });

  const { getValues, setValue, watch } = methods;

  const handleSubmit = () => {
    if (getValues("amenities")) {
      handleAmenityChange(watch("amenities"));
    }
    setTimeout(() => {
      handleFindByAmenities();
    }, 1);
  };

  useEffect(() => {
    if (show) {
      setValue("amenities", selectedAmenities);
    }

    // eslint-disabel-next-line
  }, [show]);

  return (
    <Modal
      centered
      show={show}
      onHide={closeModal}
      className="home-modal"
      contentClassName="bg-light"
    >
      <Modal.Header>
        <div className="d-flex justify-content-end w-100">
          <div className="d-flex justify-content-between w-100">
            <div className="property-type-modal-heading">
              Must Have Amenities
            </div>
            <img
              src={CloseAdminModalIcon}
              className="pointer"
              onClick={closeModal}
              alt={EMPTY_STRING}
            />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="home-modal-body">
        <div className="d-flex gap-2 flex-wrap">
          <FormProvider {...methods}>
            <form>
              {ammenities.map((type) => (
                <>
                  <SurveyFormField
                    name="amenities"
                    multiple
                    key={type.id}
                    variant={TYPE_RADIO}
                    label={type.title}
                    value={type.id}
                    endAdornment={
                      <div className="position-absolute marks-adornment">
                        <CustomSvg
                          src={FeaturesIconMapping[type.icon]}
                          className="amenities-modal-icon"
                        />
                      </div>
                    }
                  />
                </>
              ))}
            </form>
          </FormProvider>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <RoundedButton onClick={handleSubmit} className="px-4">
          Submit
        </RoundedButton>
        <RoundedButton
          variant="outlined-blue"
          onClick={closeModal}
          className="px-4"
        >
          Cancel
        </RoundedButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AmenitiesModal;
